import CONST_REQUEST from '../../constants/request';
import * as api from '../../api/operation';
import apiTools from '../../utils/store'
import { getCouponRecordList } from '@/webpublicapi/operation'

const types = {
    ...apiTools.getTypes([
        'accountList',
        'couponRecordList',
    ]),
}

const getDefaultState = () => {
    return {
        ...apiTools.getStates([
            'accountList',
            'couponRecordList',
        ]),
    }
}

const getters = {
        ...apiTools.getGetters([
            'accountList',
            'couponRecordList',
        ])
    }

const buildAction = (apiName) => {
    return ({ commit }, params) => {
        return api[apiName](params).then((res) => {
            if (res.code == CONST_REQUEST.CODE_SUCCESS) {
                return res
            } else {
                throw new Error(res.msg)
            }
        })
    }
}

const actions = {
        ...apiTools.getActions([
            'getAccountList',
            'getCouponRecordList',
        ], { types, api, CONST_REQUEST }),
        addAccount: buildAction('addAccount'),
        editAccount: buildAction('editAccount'),
        deleteAccount: buildAction('deleteAccount'),
    }

const mutations = {
    ...apiTools.getMutations([
        'accountList',
        'couponRecordList',
    ], { types, CONST_REQUEST })
}


export default {
    namespaced: true,
    state: getDefaultState(),
    getters,
    actions,
    mutations
}